import { ReactNode } from "react";
import { View } from "./View";

export interface ISettingsLinksProps {
    iconLeft: ReactNode;
    iconRight?: ReactNode;
    title: string;
    subtitle?: string;
    hideDivider?: boolean;
    urlTarget: string;
}

export const SettingsLinks = (props: ISettingsLinksProps) => {
  return <View {...props} />;
};
